module.exports = __webpack_public_path__ + "static/media/message.2496c194.svg";